import { useState } from 'react';
import { Tabs, type TabItem } from '../../components/ui/Tabs';
import { useI18nTranslation } from '../../lib/use-i18n-translation';
import { CompatibilityTab } from './CompatibilityTab';
import { ProtocolsTab } from './ProtocolsTab';
import { RoutesTab } from './RoutesTab';
import { ScenariosTab } from './ScenariosTab';
import { ValidityRulesTab } from './ValidityRulesTab';

type ConditionsTab = 'scenarios' | 'routes' | 'protocols' | 'rules' | 'compatibility';

/**
 * Scenarios · Routes · Protocols · Validity rules · Compatibility — everything a run is measured and judged
 * against, in the order a reader meets it: the conditions first, then the rules applied to them.
 */
export const ConditionsPage = () => {
  const { t } = useI18nTranslation();
  const [tab, setTab] = useState<ConditionsTab>('scenarios');

  const tabs: readonly TabItem<ConditionsTab>[] = [
    { value: 'scenarios', label: t('conditions.tabs.scenarios') },
    { value: 'routes', label: t('conditions.tabs.routes') },
    { value: 'protocols', label: t('conditions.tabs.protocols') },
    { value: 'rules', label: t('conditions.tabs.rules') },
    { value: 'compatibility', label: t('conditions.tabs.compatibility') },
  ];

  return (
    <div className="space-y-4">
      <div>
        <h1 className="text-2xl font-semibold text-foreground">{t('conditions.title')}</h1>
        <p className="mt-1 text-sm text-muted-foreground">{t('conditions.subtitle')}</p>
      </div>

      <Tabs
        items={tabs}
        value={tab}
        onChange={setTab}
      />

      {tab === 'scenarios' ? <ScenariosTab /> : null}
      {tab === 'routes' ? <RoutesTab /> : null}
      {tab === 'protocols' ? <ProtocolsTab /> : null}
      {tab === 'rules' ? <ValidityRulesTab /> : null}
      {tab === 'compatibility' ? <CompatibilityTab /> : null}
    </div>
  );
};
